import React from 'react';
import { SeoLink } from './CategoryMegaNav.styles';
import type { ResolvedMegaNavLink, ResolvedMegaNavSlot } from './useResolvedMegaNav';

type MegaNavSeoLinksProps = Readonly<{ slots: ReadonlyArray<ResolvedMegaNavSlot> }>;

/**
 * Hidden anchors for every destination the mega nav can reach, so crawlers see the
 * deep links even though the panel only renders client-side on hover
 * (pattern: `shared/components/Marcom/AppNavBar/components/SeoHeaderLinks`).
 */
export const MegaNavSeoLinks = ({ slots }: MegaNavSeoLinksProps) => {
  const linksByHref = new Map<string, ResolvedMegaNavLink>();
  const add = (link: ResolvedMegaNavLink | undefined) => {
    if (link && !linksByHref.has(link.href)) linksByHref.set(link.href, link);
  };
  for (const slot of slots) {
    add(slot.link);
    slot.tiles?.forEach(add);
    for (const column of slot.columns) column.links.forEach(add);
  }

  return (
    <>
      {Array.from(linksByHref.values()).map(link => (
        <SeoLink
          key={link.href}
          href={link.href}
          data-testid="category-mega-nav-seo-link"
        >
          {link.label}
        </SeoLink>
      ))}
    </>
  );
};
